import React from 'react';
import { Alert } from '@storebrand-digital/pretzel';
import { FallbackProps } from 'react-error-boundary';
import { getText } from '@storebrand-digital/fms-translations';
import styles from './ErrorFallbackRender.module.css';

function errorFallbackRender(_: FallbackProps) {
  return (
    <div className={styles.errorBoundaryBase}>
      <Alert heading={getText('error.sentry.title')} variant="error" />
    </div>
  );
}

export default errorFallbackRender;
